import React, { useState } from "react";
import { Plus, Minus } from "lucide-react";
import CTAButton from "@/components/CTAButton";
import Reveal from "@/components/Reveal";
import { LINKS } from "@/lib/content";
import { useT } from "@/lib/i18n";

export default function FAQ() {
    const { t } = useT();
    const [openIdx, setOpenIdx] = useState(0);
    return (
        <main className="pt-[72px] md:pt-[80px]" data-testid="faq-page">
            <section className="relative overflow-hidden">
                <div className="absolute inset-0 bg-grid opacity-40 -z-10" />
                <div className="container-x pt-24 md:pt-32 pb-12">
                    <Reveal>
                        <div className="flex items-center gap-3 mb-6">
                            <span className="w-8 h-px bg-[color:var(--accent)]" />
                            <span className="eyebrow">{t.faq.eyebrow}</span>
                        </div>
                        <h1
                            className="font-display text-4xl sm:text-5xl md:text-6xl leading-[1.05] tracking-tight text-white max-w-4xl"
                            data-testid="faq-heading"
                        >
                            {t.faq.headingA}
                            <br />
                            <span className="text-white/50">
                                {t.faq.headingB}
                            </span>
                        </h1>
                    </Reveal>
                </div>
            </section>

            <section className="pb-24 md:pb-32">
                <div className="container-x max-w-3xl">
                    <div className="border-t border-white/10">
                        {t.faq.items.map((item, i) => {
                            const open = openIdx === i;
                            return (
                                <div
                                    key={i}
                                    className="border-b border-white/10"
                                    data-testid={`faq-item-${i}`}
                                >
                                    <button
                                        type="button"
                                        className="w-full flex items-center justify-between gap-4 py-6 text-left text-white group"
                                        onClick={() =>
                                            setOpenIdx(open ? -1 : i)
                                        }
                                        aria-expanded={open}
                                        data-testid={`faq-toggle-${i}`}
                                    >
                                        <span className="font-display text-lg md:text-xl leading-snug group-hover:text-[color:var(--accent)] transition-colors">
                                            {item.q}
                                        </span>
                                        <span className="shrink-0 inline-flex items-center justify-center w-9 h-9 rounded-full border border-white/15 text-white/70 group-hover:border-[color:var(--accent)] group-hover:text-[color:var(--accent)] transition-colors">
                                            {open ? (
                                                <Minus size={16} />
                                            ) : (
                                                <Plus size={16} />
                                            )}
                                        </span>
                                    </button>
                                    <div
                                        className={`grid transition-[grid-template-rows] duration-300 ease-out ${
                                            open
                                                ? "grid-rows-[1fr]"
                                                : "grid-rows-[0fr]"
                                        }`}
                                    >
                                        <div className="overflow-hidden">
                                            <p className="pb-6 pr-12 text-white/70 leading-relaxed">
                                                {item.a}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>

                    <div className="mt-16 p-8 md:p-10 rounded-lg border border-white/10 bg-[color:var(--bg-surface)] text-center">
                        <p className="eyebrow">{t.faq.notFoundEyebrow}</p>
                        <h3 className="mt-3 font-display text-2xl md:text-3xl text-white tracking-tight">
                            {t.faq.notFoundHeading}
                        </h3>
                        <div className="mt-6 flex flex-col sm:flex-row gap-3 justify-center">
                            <CTAButton
                                href={LINKS.consultation}
                                external
                                testId="faq-cta-consultation"
                            >
                                {t.faq.ctaConsultation}
                            </CTAButton>
                            <a
                                href="/#kapcsolat"
                                className="btn-secondary"
                                data-testid="faq-cta-contact"
                            >
                                {t.faq.ctaContact}
                            </a>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    );
}
